import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { removeConcepts } from 'scenes/Gallery/GalleryPage/Concepts/sources/concepts';
import CustomBodyText from 'scenes/Gallery/components/CustomBodyText';

import { remove, model } from '../queryKeyFactory';

export const useRemove = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const removeMutation = useMutation(remove(), removeConcepts, {
    successMessage: () => `Concept deleted`,
    refreshOptions: {
      withoutQueryKey: ({ ids }) => model(ids[0]),
    },
  });

  const handleAction = async ({ id, name }) => {
    await showModal({
      title: `Delete Concept?`,
      confirmActionLabel: 'Delete',
      bodyText: <CustomBodyText name={name} />,
    });
    await removeMutation.mutateAsync({ ids: [id] });
  };

  return [handleAction, removeMutation];
};
